import DataTable from "react-data-table-component";

export default function CustomTable({
   columns,
   data,
   keyField,
   columnFontSize = "18px",
   totalCount,
   rowsPerPage,
   pagination = true,
   onChangeRowsPerPage,
   onChangePage,
   paginationServer,
}) {
   const style = {
      table: {
         style: {
            border: "1px solid #007BFF", // Set border color
            borderRadius: "5px 5px 0 0",
         },
      },
      rows: {
         style: {
            //  minHeight: "72px", // override the row height
            border: "1px solid #007BFF",
         },
      },

      headCells: {
         style: {
            padding: "0.5rem 1rem ",
            backgroundColor: "#007BFF",
            color: "#fff",
            fontSize: columnFontSize,
            fontWeight: "400",
            marginBottom: "-1px",
         },
      },
      cells: {
         style: {
            padding: "0.2rem 1rem",
            fontSize: "14px", // Set font size for regular cells
            //  borderRight: "1px solid #007BFF",
            fontSize: "14px",
         },
      },
   };

   if (!Array.isArray(data)) {
      return <div>No data found</div>;
   }

   return (
      <div style={{ width: "100%" }}>
         <DataTable
            columns={columns}
            data={data}
            keyField={keyField || "id"}
            customStyles={style}
            sortable
            fixedHeader
            pagination={pagination}
            responsive
            dense
            borderColor="#000000"
            paginationServer={paginationServer}
            paginationTotalRows={totalCount}
            paginationPerPage={rowsPerPage}
            onChangeRowsPerPage={onChangeRowsPerPage}
            onChangePage={onChangePage}
         ></DataTable>
      </div>
   );
}
